import { useProgramSelectorStateContext } from './context.js';

export default function useProgramsList(Component) {
  const { programs } = useProgramSelectorStateContext();

  return programs || [];
}
